import axios from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";

export const PrepareUserData = (data) => {
  const body = {
    address: data.address,
    cellNumber: data.phoneNumber,
    city: "",
    description: "",
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    organization: {
      address: "",
      cellNumber: "",
      description: "",
      email: "",
      id: 1,
      name: "",
      phoneNumber: "",
    },
    password: data.password,
    phoneNumber: "",

    roles: data.roles,
    userName: data.userName,
  };
  return body;
};

/**for update user  */
export const updateUserdata = (data) => {
  const body = {
    address: "",
    cellNumber: data.phoneNumber,
    city: "",
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    password: "",
    roles: data.role,
    /* "userName": data.id */
  };
  return body;
};

export const Createuser = (body) => {
  return axiosInstance.post(`/createNewUser`, JSON.stringify(body), {
    headers: { "Content-Type": "application/json" },
  });
};

export const getUser = (userId) => {
  return axiosInstance.get(`/user/${userId}`);
};

export const getAllUsers = () => {
  return axiosInstance.get(`/getAllUsers`);
};

export const updateUser = (userId, userData) => {
  return axiosInstance
    .put(`/user/${userId}`, userData, {
      headers: {
        "Content-Type": "application/json", // Set the content type to JSON
      },
    })
    .then((response) => {
      console.log(response);
      return response;
      /* return response.data.response[0]; */
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};

export const deleteUser = (id) => {
  return axiosInstance
    .delete(`/user/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const message = error.message;
    return { errors: [message] };
  }
};